// True only in `vite` dev mode when the mock layer is active: the default,
// unless a real API is configured (VITE_API_MODE=proxy -> same-origin /api
// proxy, or VITE_API_BASE_URL=<origin> -> direct calls with credentials). In a
// production build `import.meta.env.DEV` is the literal false, so every branch
// behind this helper (and the dynamic import of the sample data) is dead code.
export function isMockMode(): boolean {
  if (!import.meta.env.DEV) return false;
  const base = import.meta.env.VITE_API_BASE_URL as string | undefined;
  return import.meta.env.VITE_API_MODE !== 'proxy' && !base;
}
